import React from "react";
import PropTypes from "prop-types";

import Modal from "../Modal";
import ButtonModal from "../ButtonModal";
import styles from "./styles.module.scss";

const MarkdownImage = ({ alt, src }) => {
  return (
    <ButtonModal
      Button={({ onClick }) => (
        // eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events
        <a onClick={onClick} role="button" tabIndex={0}>
          <img className={styles.image} src={src} title={alt} alt={alt} />
        </a>
      )}
      Modal={({ modalVisible, onClose }) => (
        <Modal visible={modalVisible} onClose={onClose} name={alt}>
          <div className={styles.modalImage}>
            <img className={styles.image} src={src} title={alt} alt={alt} />
          </div>
        </Modal>
      )}
    />
  );
};

MarkdownImage.propTypes = {
  alt: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired
};

export default MarkdownImage;
